<template>
  <div class="members EOPPBlock">
    <div class="representativeHeader">
      <span class="representativeTitle">INTEGRANTES</span>
    </div>

    <div class="counter">GRADUAÇÃO: {{ oe.numberOfStudents }} integrantes</div>

    <hr class="frontier" />

    <div class="distribuition listMember">
      <span class="distribuitionTitle">
        Distribuição dos integrantes por cursos
      </span>

      <span class="distribuitionNumber">{{ oe.numberOfStudents }}</span>
    </div>

    <hr class="frontier" />

    <div class="course" v-for="(graduate, i) in oe.membersPerCourse" :key="i">
      <div class="listMember">
        <span class="courseName">{{ i + 1 }}. {{ graduate.course }}</span>

        <span class="courseNumber">{{ graduate.quantity }}</span>
      </div>
      <hr class="frontier" />
    </div>

    <div class="diversity listMember">
      <span class="distribuitionTitle">Diversidade & Inclusão</span>

      <span class="distribuitionNumber">
        {{
          Number(oe.numberOfWomenStudents) +
            Number(oe.numberOfBlackStudents) +
            numberLGBT
        }}
      </span>
    </div>

    <hr class="frontier" />

    <div class="listMember">
      <span class="courseName">1. Mulheres</span>

      <span class="courseNumber">
        {{ Number(oe.numberOfWomenStudents) + 0 }}
      </span>
    </div>

    <hr class="frontier" />

    <div class="listMember">
      <span class="courseName">2. Pretos</span>

      <span class="courseNumber">
        {{ Number(oe.numberOfBlackStudents) + 0 }}
      </span>
    </div>

    <hr class="frontier" />

    <div class="listMember">
      <span class="courseName">3. LGBTQIA+</span>

      <span class="courseNumber" v-if="oe.LGBTStudents">
        {{ Number(oe.LGBTStudents) + 0 }}
      </span>

      <span class="courseNumber" v-else>
        {{ Number(oe.numberOfLGBTStudents) + 0 }}
      </span>
    </div>

    <hr class="frontier" />

    <div class="listMember">
      <span class="courseName">4. Outras Minorias</span>

      <span class="courseNumber">
        <b-tooltip
          v-if="oe.otherMinorities != ''"
          :label="oe.otherMinorities"
          position="is-bottom"
          style="width: fit-content;"
        >
          <div class="info">i</div>
        </b-tooltip>
        <div v-else>0</div>
      </span>
    </div>
    <br />
  </div>
</template>

<script>
export default {
  name: "Members",

  props: ["oe"],

  computed: {
    numberLGBT() {
      if (this.oe.LGBTStudents) {
        return Number(this.oe.LGBTStudents);
      } else {
        return Number(this.oe.numberOfLGBTStudents);
      }
    }
  }
};
</script>

<style>
.representativeHeader {
  background: rgb(2, 209, 168);
  background: linear-gradient(
    90deg,
    rgba(2, 209, 168, 1) 0%,
    rgba(95, 255, 223, 1) 100%,
    rgba(60, 247, 210, 1) 100%
  );
  border: transparent;
  border-radius: 0.5rem 0.5rem 0 0;
  display: flex;
}
.representativeTitle {
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  margin-left: 2rem;
  margin-top: 0.5rem;
}
.members {
  margin-top: 0.5rem;
}

.counter {
  padding: 2rem;
  font-weight: 600;
  font-size: 1.5rem;
  color: black;
}

.frontier {
  height: 0.5rem;
  width: 100%;
  background-color: rgb(240, 240, 240);
  margin: 0 0;
  display: block;
}

.listMember {
  width: 80%;
  display: flex;
  margin-left: auto;
  margin-right: auto;
  padding-right: 1rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.distribuition,
.diversity {
  border-bottom-color: black;
  border-bottom-style: solid;
  border-bottom-width: initial;
}

.distribuitionTitle,
.distribuitionNumber {
  font-size: 1.5rem;
  font-weight: 600;
}

.distribuitionNumber,
.courseNumber {
  display: block;
  margin-left: auto;
  margin-right: 0;
  width: fit-content;
}

.courseName,
.courseNumber {
  font-size: 1.3rem;
}

.info {
  margin-right: -0.8rem;
  background-color: #02f8c7;
  width: 2rem;
  height: 2rem;
  border-radius: 100%;
  text-align: center;
}

@media (max-width: 640px) {
  .counter {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .counter,
  .distribuitionTitle,
  .distribuitionNumber {
    font-size: 1.2rem;
  }
  .courseName,
  .courseNumber {
    font-size: 1rem;
  }
}
</style>
